import { useReducer } from 'react';

type State = {
  currentProductId: string | null;
  isRemoveProductModalOpen: boolean;
};

type Action =
  | { type: 'SET_CURRENT_PRODUCT_ID'; payload: string | null }
  | { type: 'TOGGLE_REMOVE_PRODUCT_MODAL'; payload: boolean };

export const initialState: State = {
  currentProductId: null,
  isRemoveProductModalOpen: false,
};

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_CURRENT_PRODUCT_ID':
      return { ...state, currentProductId: action.payload };
    case 'TOGGLE_REMOVE_PRODUCT_MODAL':
      return { ...state, isRemoveProductModalOpen: action.payload };
    default:
      return state;
  }
};

export const useOptionCard = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const showRemoveProduct = (productId: string | null) => {
    dispatch({ type: 'SET_CURRENT_PRODUCT_ID', payload: productId });
    dispatch({
      type: 'TOGGLE_REMOVE_PRODUCT_MODAL',
      payload: productId ? true : false,
    });
  };

  const removeProduct = () => {
    dispatch({ type: 'SET_CURRENT_PRODUCT_ID', payload: null });
    dispatch({ type: 'TOGGLE_REMOVE_PRODUCT_MODAL', payload: false });
  };

  return {
    state,
    removeProduct,
    showRemoveProduct,
  };
};
